require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.12@core-js/modules/es7.symbol.observable.js
// module id = 5SCC
// module chunks = 16